import React from 'react';
import PropTypes from 'prop-types';
import FormResult from '../../../FormResult';
import './FormFeedback.css';

const FormFeedback = ({ status }) => {
  if (!status) return null;

  const isError = status.status < 200 || status.status >= 400;
  const message = isError ? (
    <span>
      Uh oh! Something went wrong. Details: <br />
      {status.message}
    </span>
  ) : (
    `Success! ${status.message}`
  );

  return (
    <div className={`formFeedback formFeedback--${isError ? 'error' : 'success'}`}>
      <p>{message}</p>
    </div>
  );
};

FormFeedback.propTypes = {
  status: PropTypes.instanceOf(FormResult),
};

FormFeedback.defaultProps = {
  status: null,
};

export default FormFeedback;



// WEBPACK FOOTER //
// ./src/components/common/form/FormFeedback.jsx